import React, { Component } from 'react';
import { Badge, Divider, message, Popconfirm, Table } from 'antd';
import { Link } from 'react-router';
import { queryProjUpdStatus } from '@api/task';
import moment from 'moment';

class TableProj extends Component {
  componentWillMount() {}

  getProjUpdStatus = (uuid, status) => {
    queryProjUpdStatus({
      uuid,
      status,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    const { type, type2 } = this.props;
    let config = [
      // {
      //   title: "",
      //   dataIndex: "isFocus",
      //   width: "30px",
      //   render: (text, record) => {
      //     return (
      //       <span style={{ fontSize: "16px" }} onClick={this.props.isFocusOn}>
      //         <Icon
      //           type="heart"
      //           theme={text === 1 ? "filled" : "outlined"}
      //           style={{ color: text === 1 ? "#FF3333" : "#555555" }}
      //         />
      //       </span>
      //     );
      //   }
      // },
      {
        title: '项目标题',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
          if (type === 'receive') {
            return <Link to={`/task/project_detail/${record.uuid}`}>{text}</Link>;
          }
          if (type === 'launch') {
            if (type2 === 'finish') {
              return <Link to={`/task/project_detail_finish/${record.uuid}`}>{text}</Link>;
            }
            return <Link to={`/task/project_detail_manage/${record.uuid}`}>{text}</Link>;
          }
        },
      },
      {
        title: '任务分类',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => {
          switch (text) {
            case 0:
              return '绩效考核';
            case 1:
              return '政府申报';
            case 2:
              return '日常任务';
            default:
          }
        },
      },
      {
        title: '业务部门/标签',
        dataIndex: 'workorgName',
        key: 'workorgName',
        render: (text, record) => {
          return (
            <div>
              <p>{text}</p>
              <p style={{ marginBottom: '0' }}>
                {record.tags.map(item => {
                  return (
                    <span
                      style={{
                        border: '1px solid #D3D3D3',
                        borderRadius: '5%',
                        marginRight: '5px',
                      }}
                      key={item}
                    >
                      {item}
                    </span>
                  );
                })}
              </p>
            </div>
          );
        },
      },
      {
        title: '任务数',
        dataIndex: 'taskNum',
        key: 'taskNum',
      },
      {
        title: '完成数',
        dataIndex: 'taskCompletions',
        key: 'taskCompletions',
      },
      {
        title: '截止时间',
        dataIndex: 'endDate',
        key: 'endDate',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'updateDate',
        key: 'updateDate',
        render: (text, record) => {
          let day = 0;
          if (record.updateDate && record.endDate) {
            day = Math.floor((record.updateDate - record.endDate) / 86400000);
          }

          const element =
            day > 0 ? (
              <span style={{ color: 'red', marginLeft: '10px' }}>逾期{day}天</span>
            ) : (
              <span style={{ color: 'green', marginLeft: '10px' }}>提前{Math.abs(day)}天</span>
            );
          return (
            <span>
              {text ? moment.unix(text / 1000).format('YYYY-MM-DD HH:mm:ss') : ''}
              {day ? element : ''}
            </span>
          );
        },
      },
      {
        title: '状态',
        dataIndex: 'fettle',
        render: (text, record) => {
          if (record.status === 1) {
            switch (record.fettle) {
              case 1:
                return <Badge color="red" text="已逾期" />;
              case 2:
                return <Badge color="blue" text="进行中" />;
              case 3:
                return <Badge color="yellow" text="未开始" />;
              default:
            }
          } else if (record.status === 2) {
            switch (record.fettle) {
              case 1:
                return <Badge color="red" text="未完成" />;
              case 2:
                return <Badge color="green" text="已完成" />;
              case 3:
                return <Badge color="gray" text="已废弃" />;
              default:
            }
          } else if (record.status === 0) {
            return <Badge color="yellow" text="待编辑" />;
          }
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        key: 'done',
        render: (text, record) => {
          switch (record.status) {
            case 0:
              return (
                <div>
                  <a onClick={() => this.toPageEdit(record)}>编辑</a>
                  {/* <Divider type="vertical" />
                  <a ocClick={this.saveTemplate}>保存模板</a> */}
                </div>
              );
            case 1:
              return (
                <div>
                  <a onClick={() => this.toPageEdit(record)}>编辑</a>
                  <Divider type="vertical" />
                  <Popconfirm
                    placement="leftTop"
                    title="确定结束项目吗？"
                    onConfirm={() => this.handleEndProj(record.uuid)}
                    okText="确定"
                    cancelText="取消"
                  >
                    <a>结束</a>
                  </Popconfirm>
                  <Divider type="vertical" />
                  <Popconfirm
                    placement="leftTop"
                    title="确定废弃项目吗？"
                    onConfirm={() => this.handleDisProj(record.uuid)}
                    okText="确定"
                    cancelText="取消"
                  >
                    <a>废弃</a>
                  </Popconfirm>
                  {/* <Divider type="vertical" />
                  <a onClick={this.saveTemplate}>保存模板</a> */}
                </div>
              );
            case 2:
              return <div>{/* <a onClick={this.saveTemplate}>保存模板</a> */}</div>;
            default:
          }
        },
      },
    ];
    if (this.props.type === 'receive' || this.props.type2 === 'finish') {
      config = config.filter(item => item.key !== 'done');
    }
    if (this.props.type2 !== 'finish') {
      config = config.filter(item => item.key !== 'updateDate');
    }
    return config;
  };

  toPageEdit = record => {
    this.props.router.push(`/task/project_edit/${record.uuid}`);
  };

  handleEndProj = uuid => {
    this.getProjUpdStatus(uuid, 2);
  };

  handleDisProj = uuid => {
    this.getProjUpdStatus(uuid, 3);
  };

  render() {
    const { data, pagination, isLoading } = this.props;
    return (
      <Table
        size="small"
        rowKey="uuid"
        dataSource={data}
        loading={isLoading}
        pagination={pagination}
        columns={this.columns()}
        onChange={this.props.onChange}
      />
    );
  }
}

export default TableProj;



// WEBPACK FOOTER //
// ./src/components/task/project/TableProj.js